import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  navBarAndSideBarDisabled: false,
  alerts: { global: null, inline: null },
  jobQueue: [],
  actionRequired: { message: "", buttonContent: "", buttonAction: () => {} },
  session: null,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    addToJobQueue: (state, action) => {
      state.jobQueue = state.jobQueue.concat(action.payload);
    },
    removeFromJobQueue: (state, action) => {
      state.jobQueue = state.jobQueue.filter((job) => job !== action.payload);
    },
    clearJobQueue: (state) => {
      state.jobQueue = [];
    },
    disableNavBarAndSideBar: (state, action) => {
      state.navBarAndSideBarDisabled = action.payload;
    },
    setActionRequired: (state, action) => {
      state.actionRequired = action.payload;
    },
    showGlobalAlert: (state, action) => {
      state.alerts.global = action.payload;
    },
    hideGlobalAlert: (state) => {
      state.alerts.global = null;
    },
    showInlineAlert: (state, action) => {
      state.alerts.inline = action.payload;
    },
    hideInlineAlert: (state) => {
      state.alerts.inline = null;
    },
    currentSessionInfo: (state, action) => {
      state.session = { ...state.session, ...action.payload };
    },
  },
});

export const {
  addToJobQueue,
  removeFromJobQueue,
  clearJobQueue,
  disableNavBarAndSideBar,
  setActionRequired,
  showGlobalAlert,
  hideGlobalAlert,
  showInlineAlert,
  hideInlineAlert,
  currentSessionInfo,
} = appSlice.actions;

export default appSlice.reducer;
